import React from "react";
import { Helmet } from "react-helmet";

const MaharashtraSEO = () => {
  return (
    <Helmet>
      {/* 🟢 BASIC META */}
      <title>
        Buy Sex Toys in Maharashtra | Discreet Delivery in Mumbai, Pune, Nagpur
      </title>

      <meta
        name="description"
        content="Buy sex toys online in Maharashtra with 100% discreet delivery. Trusted adult store delivering to Mumbai, Pune, Thane, Nagpur, Nashik & more. Products for men, women & couples."
      />

      <meta
        name="keywords"
        content="sex toys in Maharashtra, buy sex toys Mumbai, sex toys Pune, adult toys Nagpur, sex toys Thane, sex toys Nashik, adult store Maharashtra, sex toys for men women couples"
      />

      <meta name="robots" content="index, follow" />

      {/* 🟢 CANONICAL */}
      <link
        rel="canonical"
        href="https://lushdesire.in/sex-toys-in-maharashtra"
      />

      {/* 🟢 OPEN GRAPH */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Buy Sex Toys in Maharashtra | 100% Discreet Delivery"
      />
      <meta
        property="og:description"
        content="Order premium sex toys in Maharashtra with fast & private delivery. Serving Mumbai, Pune, Thane, Nagpur & more."
      />
      <meta
        property="og:url"
        content="https://lushdesire.in/sex-toys-in-maharashtra"
      />
      <meta
        property="og:image"
        content="https://lushdesire.in/assets/og-maharashtra.jpg"
      />

      {/* 🟢 TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Sex Toys Delivery in Maharashtra | LushDesire"
      />
      <meta
        name="twitter:description"
        content="Discreet sex toys delivery across Maharashtra. Buy toys for men, women & couples online."
      />

      {/* 🟢 LOCAL SEO */}
      <meta name="geo.region" content="IN-MH" />
      <meta name="geo.placename" content="Maharashtra" />
      <meta name="geo.position" content="19.7515;75.7139" />
      <meta name="ICBM" content="19.7515, 75.7139" />

      {/* 🟢 SCHEMA */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Store",
          "name": "LushDesire Maharashtra",
          "url": "https://lushdesire.in/sex-toys-in-maharashtra",
          "logo": "https://lushdesire.in/logo.png",
          "description": "Buy sex toys online in Maharashtra with discreet packaging. Trusted adult store delivering across Maharashtra.",
          "areaServed": {
            "@type": "State",
            "name": "Maharashtra"
          },
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "Maharashtra",
            "addressCountry": "IN"
          },
          "sameAs": [
            "https://www.facebook.com/lushdesire",
            "https://www.instagram.com/lushdesire"
          ]
        }
        `}
      </script>
    </Helmet>
  );
};

export default MaharashtraSEO;
